import { render, staticRenderFns } from "./SuggestionSearch.vue?vue&type=template&id=845b4378&scoped=true&"
import script from "./SuggestionSearch.vue?vue&type=script&lang=js&"
export * from "./SuggestionSearch.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionSearch.vue?vue&type=style&index=0&id=845b4378&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845b4378",
  null
  
)

export default component.exports